// ** React Imports
import { useState, useEffect } from 'react'

// ** Next Imports

// ** MUI Imports
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

// ** Hook Imports

// ** Configs

// ** Custom Components Imports

// ** Third Party Imports

interface TimeLeft {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const Digit = ({ value, label, hiddenSm }: { value?: string; label?: string; hiddenSm?: boolean }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography
        variant={hiddenSm ? 'h3' : 'h1'}
        sx={{ fontWeight: 600, letterSpacing: 0, color: theme => theme.palette.error.dark }}
      >
        {value ? value.padStart(2, '0') : ':'}
      </Typography>
      <Typography variant='body1' fontWeight={600} letterSpacing={0} height={20}>
        {label}
      </Typography>
    </Box>
  )
}

const CountdownTimer = ({ endDate }: { endDate: string }) => {
  // ** Hooks
  const theme = useTheme()
  const hiddenSm = useMediaQuery(theme.breakpoints.down('sm'))

  const calculateTimeLeft = (): TimeLeft => {
    const difference = +new Date(`${endDate} 23:59:59`) - +new Date()
    let timeLeft: TimeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 }

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearTimeout(timer)
  })

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        py: hiddenSm ? 8 : 8,
        px: hiddenSm ? 4 : 4,
        backgroundColor: theme => theme.palette.error.light,
        borderRadius: 1,
        border: theme => `2px solid ${theme.palette.error.main}`
      }}
    >
      <Typography
        variant={hiddenSm ? 'h6' : 'h4'}
        fontWeight={600}
        letterSpacing={0}
        sx={{ mb: 2, color: theme => theme.myColor?.colorToggle, textAlign: 'center' }}
      >
        Rekrutmen ini akan ditutup dalam
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: hiddenSm ? 2 : 5 }}>
        <Digit value={timeLeft.days.toString()} label='Hari' hiddenSm={hiddenSm} />
        <Digit hiddenSm={hiddenSm} />
        <Digit value={timeLeft.hours.toString()} label='Jam' hiddenSm={hiddenSm} />
        <Digit hiddenSm={hiddenSm} />
        <Digit value={timeLeft.minutes.toString()} label='Menit' hiddenSm={hiddenSm} />
        <Digit hiddenSm={hiddenSm} />
        <Digit value={timeLeft.seconds.toString()} label='Detik' hiddenSm={hiddenSm} />
      </Box>
    </Box>
  )
}

export default CountdownTimer
